/**
 * 回傳 Solutions Page 每個 Component 的 ID
 * @param navigable: String | Undefined, index: Number
 * @returns String | Null
 */

const provideSolutionsID = (
  navigable: string | undefined,
  index: number
): string | null => {
  if (navigable) {
    const result = navigable.replace(/\s/g, '');
    if (result) {
      return `${result.toLocaleLowerCase()}_${index}`;
    }
  }
  return null;
};

export default provideSolutionsID;
